/**
 * Polymarket Magic Link users have USDC in a POLY_PROXY (Non-Safe Proxy Wallet),
 * not in the EOA. This derives the proxy address deterministically via CREATE2.
 * @see https://github.com/Polymarket/magic-proxy-builder-example
 */
import { getCreate2Address, keccak256, encodePacked, type Address } from 'viem'

const PROXY_FACTORY = '0xaB45c5A4B0c941a2F231C04C3f49182e1A254052' as Address
const PROXY_INIT_CODE_HASH = '0xd21df8dc65880a8606f09fe0ce3df9b8869287ab0b058be05aa9e8af6330a00b' as `0x${string}`

export function deriveProxyAddress(eoaAddress: string): string {
  return getCreate2Address({
    bytecodeHash: PROXY_INIT_CODE_HASH,
    from: PROXY_FACTORY,
    salt: keccak256(encodePacked(['address'], [eoaAddress as Address])),
  })
}
